export const CLIENT_CHANNEL = {
  PC: 4,
  H5: 1,
  ANDROID: 2,
  IOS: 3
}